module.exports = __webpack_public_path__ + "img/Empfangen_reihenfolge_2.517d6acd.png";